<fury-page-layout mode="card">
  <fury-page-layout-header>
    <fury-breadcrumbs [@fadeInRight]  current="Covered Item Details"></fury-breadcrumbs>
  </fury-page-layout-header>
  <fury-page-layout-content [@fadeInUp]>
    <h1 class="margin-0">{{itemDetails?.title}}</h1>
    <div class="describ-item">
      <div class="col-title">
        <h3>Description</h3>
      </div>
      <div class="col-desc">
        <p>
          {{itemDetails?.description}}
        </p>
      </div>
    </div>
    <div class="imgBox">
      <img
        [src]="itemDetails?.image ? itemDetails?.image : './assets/img/no_thumbnail.jpg'"
        alt="">
    </div>
    <div class="describ-item">
      <div class="col-title">
        <h3 *ngIf="itemDetails?.averageCostForRepair && itemDetails?.averageCostForRepair !== 'N/A'">
          Average Cost of Repair
        </h3>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.averageCostForRepair && itemDetails?.averageCostForRepair !== 'N/A'">
          <p>
            ${{itemDetails?.averageCostForRepair}}
          </p>
        </div>
      </div>
    </div>


    <div class="describ-item">
      <div class="col-title">
        <div *ngIf="itemDetails?.averageCostForReplacement">
          <h3>Average Cost to Replace</h3>
        </div>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.averageCostForReplacement">
          <p>
            ${{itemDetails?.averageCostForReplacement}}
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item">
      <div class="col-title">
        <div>
          <h3 *ngIf="itemDetails?.coverageHighlights.length > 0"> Coverage Highlights </h3>
        </div>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.coverageHighlights.length > 0">
          <p *ngFor="let item Of itemDetails?.coverageHighlights">{{item ? item : ''}}</p>
        </div>
      </div>
    </div>

    <div class="describ-item">
      <div class="col-title">
        <div *ngIf="itemDetails?.additionalInformation && itemDetails?.additionalInformation !== 'N/A'">
          <h3>Additional Information</h3>
        </div>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.additionalInformation && itemDetails?.additionalInformation !== 'N/A'">
          <p>
            {{itemDetails?.additionalInformation}}
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item" *ngIf="itemDetails?.whatWeCover">
      <div class="col-title">
        <div>
          <h3>What We Cover</h3>
        </div>
      </div>
      <div class="col-desc">
        <div>
         
          <p [innerHTML]="itemDetails?.whatWeCover">
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item" *ngIf="itemDetails?.typeOfSystemWeCover.length > 0">
      <div class="col-title">
        <div>
          <h3>Type of systems we cover</h3>
        </div>
      </div>
      <div class="col-desc">
        <div>
          <p *ngFor="let item Of itemDetails?.typeOfSystemWeCover;let i=index" class="d-inline">
            {{i===(itemDetails?.typeOfSystemWeCover.length-1)? item : item+','}}
          </p>
        </div>
      </div>
    </div>
    <div class="describ-item">
      <div class="col-title">
        <div *ngIf="itemDetails?.freonCoverage">
          <h3>Freon Coverage</h3>
        </div>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.freonCoverage">
          <p>
            {{itemDetails?.freonCoverage}}
          </p>
        </div>
      </div>
    </div>
    <div class="describ-item"
      *ngIf="itemDetails?.additionalInformationForWhatWeCover && itemDetails?.additionalInformationForWhatWeCover !== 'N/A'">
      <div class="col-title">
        <div>
          <h3>Additional Information for What we cover</h3>
        </div>
      </div>
      <div class="col-desc">
        <div>
          <p>
            {{itemDetails?.additionalInformationForWhatWeCover}}
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item" *ngIf="itemDetails?.notCovered">
      <div class="col-title">
        <div>
          <h3>Not Covered</h3>
        </div>
      </div>
      <div class="col-desc">
        <div>
         
          <p [innerHTML]="itemDetails?.notCovered">
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item" *ngIf="itemDetails?.followingSystemTypesNotCovered.length > 0">
      <div class="col-title">
        <div>
          <h3>The following type of systems are not covered</h3>
        </div>
      </div>
      <div class="col-desc">
        <div>
          <p *ngFor="let item of itemDetails?.followingSystemTypesNotCovered; let i=index" class="d-inline">
            {{i===(itemDetails?.followingSystemTypesNotCovered.length -1) ? item : item+' |'}}
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item">
      <div class="col-title">
        <div
          *ngIf="itemDetails?.additionalInformationForNotCovered && itemDetails?.additionalInformationForNotCovered !== 'N/A'">
          <h3>Additional Information for Not Covered</h3>
        </div>
      </div>
      <div class="col-desc">
        <div
          *ngIf="itemDetails?.additionalInformationForNotCovered && itemDetails?.additionalInformationForNotCovered !== 'N/A'">
          <p>
            {{itemDetails?.additionalInformationForNotCovered}}
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item">
      <div class="col-title">
        <div *ngIf="itemDetails?.maximumCoverage && itemDetails?.maximumCoverage !== 'N/A'">
          <h3>
            Maximum Coverage
          </h3>
        </div>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.maximumCoverage && itemDetails?.maximumCoverage !== 'N/A'">
          <p>
            {{itemDetails?.maximumCoverage}}
          </p>
        </div>
      </div>
    </div>



    <div class="col-title">
      <div
        *ngIf="itemDetails?.standardPrice && itemDetails?.standardPrice !== 'N/A' || itemDetails?.customPrice && itemDetails?.customPrice !== 'N/A'">
        <h2>
          More Information:
        </h2>
      </div>
    </div>
    <div class="describ-item">
      <div class="col-title">
        <div *ngIf="itemDetails?.standardPrice && itemDetails?.standardPrice !== 'N/A'">
          <h3>Standard Price</h3>
        </div>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.standardPrice && itemDetails?.standardPrice !== 'N/A'">
          <p>
            ${{itemDetails?.standardPrice}}
          </p>
        </div>
      </div>
    </div>

    <div class="describ-item">
      <div class="col-title">
        <div *ngIf="itemDetails?.customPrice && itemDetails?.customPrice !== 'N/A'">
          <h3>Custom Price</h3>
        </div>
      </div>
      <div class="col-desc">
        <div *ngIf="itemDetails?.customPrice && itemDetails?.customPrice !== 'N/A'">
          <p>
            ${{itemDetails?.customPrice}}
          </p>
        </div>
      </div>
    </div>
    <div class="describ-item" *ngIf="itemDetails?.maximumCoverageIncreaseFee">
      <div class="col-title">
        <h3>Maximum Coverage Increase Fee</h3>
      </div>
      <div class="col-desc">
        <p>
          {{itemDetails?.maximumCoverageIncreaseFee}}%
        </p>
      </div>
    </div>
    <div class="describ-item" *ngIf="itemDetails?.maximumCoverageDecreaseFee">
      <div class="col-title">
        <h3>Maximum Coverage Decrease Fee</h3>
      </div>
      <div class="col-desc">
        <p>
          {{itemDetails?.maximumCoverageDecreaseFee}}%
        </p>
      </div>
    </div>
    <div class="describ-item" *ngIf="itemDetails?.maximumAllowedDecrease">
      <div class="col-title">
        <h3>Maximum Allowed Decrease</h3>
      </div>
      <div class="col-desc">
        <p>
          ${{itemDetails?.maximumAllowedDecrease}}
        </p>
      </div>
    </div>
    <div class="describ-item" *ngIf="itemDetails?.maximumAllowedIncrease">
      <div class="col-title">
        <h3>Maximum Allowed Increase</h3>
      </div>
      <div class="col-desc">
        <p>
          ${{itemDetails?.maximumAllowedIncrease}}
        </p>
      </div>
    </div>
    <div class="describ-item" *ngIf="itemDetails?.itemRemovalPrice">
      <div class="col-title">
        <h3>Item Removal Price</h3>
      </div>
      <div class="col-desc">
        <p>
          ${{itemDetails?.itemRemovalPrice}}
        </p>
      </div>
    </div>

    <div class="describ-item" *ngIf="itemDetails?.itemType">
      <div class="col-title">
        <h3>Item Type</h3>
      </div>
      <div class="col-desc">
        <p>
          {{itemDetails?.itemType | titlecase}}
        </p>
      </div>
    </div>
    <button mat-button type="button" class="can-button" (click)="navigate()"><span>Back</span></button>
    
  </fury-page-layout-content>
</fury-page-layout>



  
